import styled from 'styled-components';

const TabButton = styled.button(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[0]};
    font-size: ${type.size.regular};
    border-bottom: 2px solid ${color.grayscale[700]};
    line-height: 1.25rem;
    padding: 11px;
    
    &.active {
      color: ${color.primary.regular};
      border-bottom: 2px solid ${color.primary.regular};
    }

    &:hover:not(.active) {
      border-bottom: 2px solid ${color.grayscale[400]};
    }
  `;
});

const Tab = ({ id, active, callback, title }) => {
  return (
    <TabButton
      className={active ? 'active' : ''}
      role="tab"
      tabIndex={active ? -1 : 0}
      aria-selected={active}
      aria-controls={`tournament-panel-${id}`}
      id={`tournament-tab-${id}`}
      onClick={callback}
    >
      {title}
    </TabButton>
  );
};

export default Tab;
